<template>
  <div class="choice-question__custom-field-container">
    <button
      v-if="selected"
      data-test-id="ChoiceText_DeleteButton"
      class="choice-question__input-clear"
      @click="clearInput"
    >
      <img :src="binIcon" alt="X" />
    </button>
    <input
      ref="inputRef"
      v-model="textInput"
      data-test-id="ChoiceText_Input"
      :class="{
        'choice-question__field': true,
        'choice-question__field--selected': selected,
      }"
      type="text"
      :placeholder="c('other')"
      :disabled="disabled"
      :aria-selected="selected"
      role="option"
      autocomplete="off"
      @paste="
        e => {
          e.preventDefault()
        }
      "
      @drop="
        e => {
          e.preventDefault()
        }
      "
      @input="
        e => {
          if (textInput.length > 0)
            return emit('updatedTextChoice', (e.target as HTMLInputElement).value)
          return emit('updatedTextChoice', '')
        }
      "
      @click="
        e => {
          if (textInput.length > 0) emit('updatedTextChoice', (e.target as HTMLInputElement).value)
        }
      "
    />
  </div>
</template>
<script lang="ts">
import { ref } from 'vue'

import { c } from '../../../intl'
import binIcon from '../../assets/white-trash.svg'

export default {
  props: {
    selected: { required: true, type: Boolean },
    disabled: { required: true, type: Boolean },
  },
  emits: {
    updatedTextChoice: (_newValue: string) => true,
  },
  setup(_props, { emit }) {
    const textInput = ref('')
    const inputRef = ref<HTMLInputElement | null>(null)
    const clearInput = (): void => {
      textInput.value = ''
      emit('updatedTextChoice', '')
    }
    const focusTextField = (): void => {
      inputRef.value?.focus()
    }
    return { emit, textInput, clearInput, binIcon, c, focusTextField, inputRef }
  },
}
</script>
<style lang="postcss">
.choice-question {
  &__custom-field-container {
    position: relative;
    display: flex;
  }
  &__input-clear {
    padding: 0.3rem 0.5rem;
    width: 3rem;
    border: 0;
    background-color: transparent;
    background-color: var(--color-danger);
    cursor: pointer;
  }
}
</style>
